22<template>
  <!-- ----------------------------------------------------------------------------- -->
  <!-- DatatablesCRUDActions -->
  <!-- ----------------------------------------------------------------------------- -->
  <div>

    <div class="mt-4">
      <v-card-title>
      
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        
      ></v-text-field>
    </v-card-title>
      
      <v-data-table :headers="headers" :search='search' :items="programs" sort-by="Date" :sort-desc='true' class="border">
        <template v-slot:item.Date="{ item }">
    <span>{{ new Date(item.Date).toLocaleDateString() }}</span>
  </template>
  <template v-slot:item.Logged="{ item }">
    <span v-if='item.Logged'> <b class='green-text'>Logged</b> </span>
    <span v-else> Not Logged </span>
  </template>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Move It NQ</v-toolbar-title>
            <div style='position:absolute;right:10px;' v-if='$root.selectedLga == null'>
            <v-select :items="items" label="Filter" outlined  v-model='slFilter' class='mt-5' style='max-width:220px;'> </v-select>
            </div>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">

              <v-card>
                

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem['Event Name']" label="Program Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Date" label="Date"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.LGA" label="LGA"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Instructor" label="Instructor"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Attendance" label="Attendance"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions >
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "DatatablesCRUDActions",
  data: () => ({
      sortBy: '',
        sortDesc: false,
    slFilter:"",
    items: ['Clear'],
    search:'',
    dialog: false,
    headers: [
      {
        text: "Program Name",
        align: "start",
        sortable: false,
        value: "Event Name"
      },
      { text: "LGA", value: "LGA" },
      { text: "Status", value: "Logged" },
      { text: "Date", value: "Date" },
      { text: "Instructor", value: "Instructor" },
      { text: "Attendance", value: "Attendance" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
    }
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
       programs () {
      let data = [];
      this.$root.programs.forEach((element, index) => {
         if(this.$root.selectedLga == "All LGAs")
         {
            data.push(element)
         }else{
             if(element.LGA === this.$root.selectedLga)
              {
                data.push(element)
                console.log('matched', index)
              }
         }
      });
      return data;
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    slFilter(value){
      this.programs = [];
      if(value == "Clear"){
        this.programs = this.$root.programs
      }
      this.$root.programs.forEach((element) => {
        if(element.LGA == value){
          this.programs.push(element)
        }
      })
    }
  },
  created() {
    this.$root.programs.forEach((element) => {
      if(this.items.indexOf(element.LGA) < 0 && element.LGA !== undefined)
      this.items.push(element.LGA)
    })
    setTimeout(() => {
      this.sortBy = 'Date'
    }, 1000);
   
  },
  mounted () {
    this.initialize()
    this.slFilter = this.$root.selectedLga;
  },
  methods: {
    initialize() {
     this.programs = this.$root.programs
    },
    editItem(index) {
      this.editedIndex = this.programs.indexOf(index);
      let item =  this.programs[this.editedIndex];
      this.editedItem = {
        "Attendance":item.Attendance,
        "Logged":true,
        "Session Notes":item['Session Notes'],
        "Time Logged":item['Time Logged'],
        "ID":item.ID,
        "month":(item.month !== undefined) ? item.month : '',
        "Date":item.Date,
        "Event Name":item['Event Name'],
        "Instructor":item.Instructor,
        "LGA":item.LGA,
        "Time":item.Time,
      }
      console.log(item)
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.programs.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.programs.splice(index, 1);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      console.log('edit item id', this.editedItem.ID)
      this.$database.ref("1CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Programs/"+this.editedItem.ID)
      .set({
        "Attendance":this.editedItem.Attendance,
        "Logged":this.editedItem.Logged,
        "Session Notes":this.editedItem['Session Notes'],
        "Time Logged":this.editedItem['Time Logged'],
        "ID":this.editedItem.ID,
        "month":(this.editedItem.month !== undefined) ? this.editedItem.month : '',
        "Date":this.editedItem.Date,
        "Event Name":this.editedItem['Event Name'],
        "Instructor":this.editedItem.Instructor,
        "LGA":this.editedItem.LGA,
        "Time":this.editedItem.Time,
      })
      if (this.editedIndex > -1) {
        Object.assign(this.programs[this.editedIndex], this.editedItem);
      } else {
        this.programs.push(this.editedItem);
      }

      this.close();
    }
  }
};
</script>
<style scoped>
.green-text{
    color:green !important;
}
</style>